import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Order } from '../../helpers';
import { Section } from '../../../Common/Layout';
import { useGuard } from '../../Guard';
import EditInvoiceDetailsForm from './EditInvoiceDetailsForm';
import InvoiceDetails from '../../../../common/Invoice/InvoiceDetails';
import UI from '../../../../common/UI';
import useScroll from '../../../../common/useScroll';

export interface InvoiceDetailsSectionProps {
  order: Order;
}

const InvoiceDetailsSection = ({ order }: InvoiceDetailsSectionProps) => {
  const { t } = useTranslation();
  const { guard } = useGuard(order.participant);
  const { scrollToIfInvisible } = useScroll();

  const [showForm, setShowForm] = useState(false);

  const handleSuccess = () => {
    setShowForm(false);
    scrollToIfInvisible('InvoiceDetailsSection');
  };

  const handleCancel = () => {
    setShowForm(false);
    scrollToIfInvisible('InvoiceDetailsSection');
  };

  const invoiceDetails = {
    company_name: order.company_name,
    reference: order.reference,
    street: order.street,
    house_number: order.house_number,
    zip_code: order.zip_code,
    extra_address_line: order.extra_address_line,
    city: order.city,
    country: order.country,
    phone: order.phone,
    vat_id: order.vat_id,
    e_invoicing_recipient: order.e_invoicing_recipient,
  };

  return (
    <Section spacing="md" title={t('invoice_details')} id="InvoiceSection">
      <UI.GridContainer>
        {!showForm && (
          <UI.FadeIn>
            <UI.GridContainer>
              <InvoiceDetails {...invoiceDetails} />

              <UI.HR sc={{ dashed: true }} />

              <UI.Button
                onClick={() => guard(() => setShowForm(true))}
                sc={{ block: true }}
                aria-label={t('edit_invoice_details')}
              >
                {t('common:edit')}
              </UI.Button>
            </UI.GridContainer>
          </UI.FadeIn>
        )}
        {showForm && (
          <UI.FadeIn>
            <EditInvoiceDetailsForm
              order={order}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </UI.FadeIn>
        )}
      </UI.GridContainer>
    </Section>
  );
};

export default InvoiceDetailsSection;
